import Dexie, {Table} from 'dexie';
import {StoredPicture} from "./app/core/models/stored-picture";

export class AppDB extends Dexie {
  pictures!: Table<StoredPicture, string>;

  constructor() {
    try {
      super('CaroolDB');
      this.version(4).stores({
        pictures: ',status,key,type'
      });
      this.version(5).stores({
        pictures: ',uploadState,analysisId,capturedAt,kind'
      }).upgrade(tx => tx.table('pictures').clear());
      navigator.storage.persisted().then((result) => {
        if (!result){
          navigator.storage.persist();
        }
      });
    } catch(e){
      console.error(e);
    }
  }
}

export const dexie = new AppDB();
